var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCuteInstagram = function SvgCuteInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    x: 7,
    y: 7,
    fill: "#ed7899",
    rx: 6,
    ry: 6,
    transform: "rotate(180 32 32)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    x: 7,
    y: 7,
    fill: "#3a69ed",
    rx: 6,
    ry: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8f34bf",
    d: "M57 51V19.34A54.29 54.29 0 0 0 43.85 7H13a6 6 0 0 0-6 6v38a6 6 0 0 0 6 6h38a6 6 0 0 0 6-6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb52ce",
    d: "M57 51V28.49A49.19 49.19 0 0 0 33.4 7H13a6 6 0 0 0-6 6v38a6 6 0 0 0 6 6h38a6 6 0 0 0 6-6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0678f",
    d: "M57 51v-8.33A44 44 0 0 0 14 8a44.49 44.49 0 0 0-4.65.25A6 6 0 0 0 7 13v38a6 6 0 0 0 6 6h38a6 6 0 0 0 6-6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M14 14a38.17 38.17 0 0 0-7 .65V51a6 6 0 0 0 6 6h38a6 6 0 0 0 .67 0 38.3 38.3 0 0 0 .33-5 38 38 0 0 0-38-38Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4b998",
    d: "M14 20a32.08 32.08 0 0 0-7 .78V51a6 6 0 0 0 6 6h32.61a32.23 32.23 0 0 0 .39-5 32 32 0 0 0-32-32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6d397",
    d: "M14 26a26 26 0 0 0-7 1v24a6 6 0 0 0 6 6h26.51A26 26 0 0 0 14 26Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e3ae",
    d: "M14 32a19.91 19.91 0 0 0-7 1.28V51a6 6 0 0 0 6 6h20.34A19.93 19.93 0 0 0 14 32Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#faefde",
    d: "M14 38a13.92 13.92 0 0 0-7 1.89V51a6 6 0 0 0 6 6h14.06A14 14 0 0 0 14 38Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e3ae",
    d: "M32 19a13 13 0 1 0 0 26 13 13 0 1 0 0-26Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#bbdef9",
    d: "M32 23a9 9 0 1 0 0 18 9 9 0 1 0 0-18Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2edff",
    d: "M32 27a5 5 0 1 0 0 10 5 5 0 1 0 0-10Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "M30 27a3 3 0 1 0 0 6 3 3 0 1 0 0-6zm5.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#85cbf8",
    d: "M48 14a2 2 0 1 0 0 4 2 2 0 1 0 0-4Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M32 46a14 14 0 1 0-14-14 14 14 0 0 0 14 14Zm0-26a12 12 0 1 1-12 12 12 12 0 0 1 12-12Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M32 42a10 10 0 1 0-10-10 10 10 0 0 0 10 10Zm0-18a8 8 0 1 1-8 8 8 8 0 0 1 8-8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e3ae",
    d: "M48 13a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm0 4.47A1.47 1.47 0 1 1 49.47 16 1.47 1.47 0 0 1 48 17.47Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M51 6H13a7 7 0 0 0-7 7v38a7 7 0 0 0 7 7h38a7 7 0 0 0 7-7V13a7 7 0 0 0-7-7Zm5 45a5 5 0 0 1-5 5H13a5 5 0 0 1-5-5V13a5 5 0 0 1 5-5h38a5 5 0 0 1 5 5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M17 49a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm-5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm20 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm-30 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1z"
  })));
};
export default SvgCuteInstagram;